export enum StoreType {
  B2B = 'b2b', // Mayorista
  B2C = 'b2c', // Minorista
}
